(() => {
    'use strict';

    const clamp = (commentText, lineCount, lineClamp) => {
        const seeMoreBtn = commentText.closest('.viewer').find('.see-more-content-btn');
        seeMoreBtn.addClass('d-none');
        commentText.removeClass('single-line two-lines scroll');

        if (lineCount > lineClamp && commentText.hasClass('clamped-text')) {
            seeMoreBtn.removeClass('d-none');
        } else {
            commentText.removeClass('clamped-text');
            if (lineCount === 1) {
                commentText.addClass('single-line');
            } else if (lineCount === 2) {
                commentText.addClass('two-lines');
            }
        }
    };

    howspace.commentsTrait.clampCommentText = (widget, comments) => {
        if (!comments) {
            comments = widget.findIncludingSelf('.comments.howspace-lister .comment');
        }

        comments.findIncludingSelf('.viewer .comment-text').each(function () {
            const commentText = $(this);
            const text = commentText.find('.text');
            const textComputedStyle = window.getComputedStyle(text[0]);

            const seeMoreBtn = commentText.closest('.viewer').find('.see-more-content-btn');
            commentText.css('--see-more-btn-width', seeMoreBtn.outerWidth() + 'px');
            commentText.css('--see-more-btn-height', seeMoreBtn.outerHeight() + 'px');

            const lineHeight = parseFloat(textComputedStyle.getPropertyValue('line-height').replace('px', ''));
            const scrollHeight = text[0].scrollHeight;
            const lineCount = Math.ceil(scrollHeight / lineHeight);
            const lineClamp = commentText.css('--howspace-clamp-lines');

            howspace.idleCallback(() => {
                clamp(commentText, lineCount, lineClamp);
            });
        });
    };
})();
